export default function scrollIntoView(container, selected) {
    if (!selected) {
        container.scrollTop = 0;
        return;
    }

    const top = selected.offsetTop;
    const bottom = top + selected.offsetHeight;
    const viewRectTop = container.scrollTop;
    const viewRectBottom = viewRectTop + container.clientHeight;
    if (top < viewRectTop) {
        container.scrollTop = top;
    } 
    else if (bottom > viewRectBottom) {
        container.scrollTop = bottom - container.clientHeight;
    }
}


// WEBPACK FOOTER //
// ./src/util/scrollIntoView.js